import React from 'react';

function Quote() {
  return (
    <header className="bg-header flex items-center justify-center mx-12 h-96 pb-12 ">
      <div className=" font-serif mx-4 p-4 text-center md:p-8">
        <p className="italic text-sm"></p>

        <h1 className="lg:text-4xl  text-white lg:mx-11">
          "Providing employment is the most effective way to integrate
          immigrants into our community"
        </h1>
      </div>
    </header>
  );
}

export default Quote;
